export const idealGasConstant = 22.413969545014; // mol / cm3 at STP
